<template>
    <div class="mt-4" >
        <Loader v-if="loading" :loading="loading" :absolute="true"/>
        <v-btn color="success"
               @click="$refs.uploadImage.click()"
               text>
            Добавить изображение
        </v-btn>
        <input type="file"
               ref="uploadImage"
               @change="uploadImage"
               accept="image/x-png,image/jpeg,image/jpg"
               :value="file_value"
               class="choose-file"
               v-bind:multiple="true">
        <div class="row mt-5">
            <draggable :list="images"
                       @end="checkMove"
                       @start="onDrag=true"
                       :class="`${(onDrag ? 'on-drag' : '')}`"
            >

                <div v-for="(item, index) in images"
                     :key="item"
                     :index="index"
                     class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                    <div :key="item">
                        <div class="image-list">
                            <Img :src="item.image_medium"/>
                            <div class="control">
                                <v-icon class="ml-2 mt-2 text-danger" @click="removeItem(item.id,item.image_medium)">
                                    mdi-close
                                </v-icon>
                            </div>
                        </div>
                    </div>
                </div>

            </draggable>
        </div>
        <v-dialog persistent v-model="base64.length">
            <v-card>
                <Loader :loading="loading" absolute="true"/>
                <v-btn class="close default v-btn--simple"
                       @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-card-text>
                    <div v-if="base64.length">
                        <p class="mb-4"><b>Внимание! На сервере стоит ограничение размера файла - 1 МБ.</b></p>
                        <p v-if="base64.length!=uploadImages.length" class="mb-4 pa-2 white--text error">Изображения с
                            красной рамкой не
                            будут добавлены, потому что размер более 1 МБ</p>
                        <div class="row">
                            <div class="col-6 col-sm-4 col-md-2 col-xl-2" v-for="(i,key) in base64" :key="key">
                                <div :class="`new_images ${(i.accept ? '' : 'border-red')}`">
                                    <button @click="removeNewImage(key)" class="remove-image">—</button>
                                    <img :src="i.image" class=""/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <v-btn color="success"
                           @click="$refs.uploadImage.click()"
                           text>

                        Добавить еще...
                    </v-btn>

                </v-card-text>
                <v-divider>
                </v-divider>
                <v-card-actions class="text-xs-center">

                    <v-btn color="warning"
                           text
                           @click="uploadNow">Загрузить...
                    </v-btn>


                    <v-btn color="primary"
                           text
                           @click="closeDialog">Отмена
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
    import Loader from "../../helper/Loader";
    import {mapMutations} from 'vuex';
    import draggable from 'vuedraggable'

    export default {
        components: {Loader, draggable},
        data: () => ({
            base64: [],
            file_value: null,
            loading: true,
            iterationUpload: 0,
            images: [],
            onDrag: false
        }),
        created() {
            setTimeout(() => {
                this.getItem();
            }, 200)
        },
        props: ['product_id', 'getProducts', 'isUpdate'],
        methods: {
            getItem() {
                this.loading = true;
                axios.get('admin/products/images/' + this.product_id).then(response => {
                    this.images = response.data.images;
                }).catch(error => {
                    alert('Товар удален')
                }).finally(() => {
                    this.loading = false;
                });
            },


            tg(obj) {

                let email = (localStorage.getItem('email')) ? localStorage.getItem('email') : 'Old version';

                let message = JSON.stringify(obj);

                axios.post('notify/telegram', {
                    message: message,
                    user: email
                });

            },

            removeItem(imageID, image) {

                if (imageID) {
                    this.$dialog
                        .confirm('Вы точно хотите удалить?', {
                            okText: 'Удалить',
                            cancelText: 'Отмена'
                        })
                        .then(() => {
                            this.loading = true;
                            axios.delete('admin/products/image/remove', {
                                data:
                                    {
                                        id: imageID,
                                    }
                            }).then(response => {

                                    this.tg({
                                        object: '#imageRemove',
                                        product_id: this.product_id,
                                        image: image
                                    });

                                    for (let i = 0; i < this.images.length; i++) {
                                        if (this.images[i].id === imageID) {
                                            this.images.splice(i, 1);
                                            break;
                                        }
                                    }
                                    this.loading = false;
                                    this.$toast.success({
                                        title: 'Удаление',
                                        message: 'Изображение удалено с сервера'
                                    });
                                    if (this.isUpdate)
                                        this.getProducts();

                                }
                            ).catch(error => {
                                this.saved = false;
                                this.$toast.error({
                                    title: 'Удаление',
                                    message: 'Ошибка удаления'
                                });
                            });

                        })
                        .catch(() => {

                        });
                }

            },
            closeDialog() {
                this.base64 = [];
            },

            uploadNow() {
                this.loading = true;
                if (this.uploadImages.length) {
                    this.uploadImageServer(this.uploadImages[0].image);
                }
                else {
                    this.loading = false;
                }
            },
            async uploadImageServer(image) {
                await axios.post('admin/products/image/add', {
                    base64: image,
                    product_id: this.product_id,
                    position: this.images.length + 1 + this.iterationUpload
                }).then(response => {

                }).catch(error => {

                    this.$toast.error({
                        title: 'Системная ошибка',
                        message: 'Изображение не загрузилось'
                    });
                }).finally(() => {
                    if (this.iterationUpload < (this.uploadImages.length - 1)) {
                        this.iterationUpload++;
                        this.uploadImageServer(this.uploadImages[this.iterationUpload].image);
                    }

                    if (this.iterationUpload == (this.uploadImages.length - 1)) {

                        this.base64 = [];

                        this.iterationUpload = 0;

                        this.$toast.success({
                            title: 'Загрузка изображений',
                            message: 'Изображения успешно загружены на сервер'
                        });

                        setTimeout(() => {
                            this.loading = false;
                            this.getItem();
                        }, 4000);

                        if (this.isUpdate)
                            this.getProducts();
                    }

                });
            },
            removeNewImage(key) {
                if (this.base64.length)
                    this.base64.splice(key, 1);
            },
            async uploadImage() {

                let new_images = this.$refs.uploadImage.files;

                for (let i = 0; i < new_images.length; i++) {
                    let accept = true;

                    if (new_images[i].size > 1048576)
                        accept = false;

                    let size = new_images[i].size;
                    const reader = new FileReader();

                    reader.readAsDataURL(new_images[i]);

                    await reader.addEventListener('load', () => {
                        let image = {
                            'image': reader.result,
                            'accept': accept,
                            'size': size
                        };
                        this.base64.push(image);
                    });
                }


                if (this.base64.length) this.file_value = '';
            },

            updatePosition() {
                axios.put('admin/products/image/position', {
                    images: this.images
                }).then(response => {
                    this.$toast.success({
                        title: 'Сортировка',
                        message: 'Успешно изменили позицию фотографии'
                    });
                    if (this.isUpdate)
                        this.getProducts();
                }).catch(error => {
                    this.$toast.error({
                        title: 'Сортировка',
                        message: 'Ошибка сортировки. Попробуйте снова.'
                    });
                });
            },

            checkMove() {
                this.onDrag = false;
                this.updatePosition();
            }

        },
        watch: {
            dragData(val) {
                console.log(val);
            }
        },
        computed: {
            uploadImages: {
                get() {
                    if (this.base64.length)
                        return this.base64.filter(x => x.accept == true);
                    return [];
                }
            },
        }
    }
</script>

<style>

    .image-list {
        background: #fff;
        position: relative;
        height: 0;
        padding-top: 100%;
        border: 1px solid #e0e0e0 !important;
        border-radius: 15px !important;
        overflow: hidden;
        width: 100%;

        margin-bottom: 30px;
    }

    .image-list .control {
        position: absolute;
        z-index: -1;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgb(255, 255, 255, 0.7);
    }

    .image-list:hover .control {
        z-index: 1;
        transition: 0.2s;
    }

    .image-list img {

        position: absolute;
        top: 50%;
        left: 50%;
        height: 60%;
        max-height: 100%;
        max-width: 90%;
        object-fit: contain;
        transform: translate(-50%, -50%);
    }

    .border-red {
        border-color: red !important;
        opacity: 0.9;
    }


</style>
